// extracted by mini-css-extract-plugin
export default {"paper":"formpage_paper__0PMwF"};